<template>
    <div :class="{'has-error': !!error}" class="form-group">
        <label v-if="has_label" :class="labelClass" class="form-label" :for="id||false"><slot name="label"></slot></label>
        <div :class="{'has-icon-left': has_left_icon, 'has-icon-right': has_right_icon}" class="input-group">
            <slot name="left-addon"></slot>
            <i v-if="saving&&(glyphPosition==='left')" class="form-icon loading"></i>
            <open-icon v-if="has_left_icon" :glyph="glyph" @click.native="click_icon" class="form-icon" />
            <input
                ref="field"
                :type="standardized_type"
                :name="name"
                :id="id || false"
                :value="value"
                :size="size || false"
                :step="step"
                :max="max || false"
                :placeholder="placeholder"
                :disabled="!editable"
                :class="fieldClass"
                class="form-input"
                @focus="autoselect_action"
                @blur="blur"
                @touchstart="touchstart"
                @keydown="keydown"
            />
            <slot name="right-addon"></slot>
            <i v-if="saving&&(glyphPosition==='right')" class="form-icon loading"></i>
            <open-icon v-else-if="!saving&&has_right_icon" :glyph="glyph" @click.native="click_icon" class="form-icon" />
        </div>
        <div v-if="!!error" class="form-input-hint">{{ error }}</div>
        <div v-else-if="!!hint" class="form-input-hint">{{ hint }}</div>
    </div>
</template>

<script type="text/javascript">
import { debounce } from "lodash"

import form_input_mixin from "./form_input_mixin"
import alpha_numerical_input from "../../mixins/AlphaNumericalInput"

import { OpenIcon } from "../../nibnut/components"

export default {
    name: "FormInput",
    mixins: [form_input_mixin, alpha_numerical_input],
    components: {
        OpenIcon
    },
    methods: {
        keydown: debounce(function (event) {
            if(this.alphaNumeric && this.iOS) this.touching = false
            if(this.live) this.$emit("input", event.target.value)
            else if(event.keyCode && (event.keyCode === 13)) event.target.blur()
        }, 300),
        blur (event) {
            if(this.alphaNumeric && this.iOS) this.touching = false
            if(!this.live) this.$emit("input", event.target.value)
            this.$emit("blur", event.target.value, this.name) // can be useful for autofilled values... Use this to manually set your v-model's value
        },
        click_icon () {
            this.$refs.field.focus()
        }
    },
    computed: {
        has_label () {
            return !!this.$slots && !!this.$slots.label
        },
        has_left_icon () {
            return !this.saving && !!this.glyph && (this.glyphPosition === "left")
        },
        has_right_icon () {
            return !!this.saving || (!this.saving && !!this.glyph && (this.glyphPosition === "right"))
        },
        autoselect_on_focus () {
            return this.autoselect || (this.type.match(/^(float|number)$/i))
        },
        standardized_type () {
            if(this.type === "float") return "number"
            return this.type
        },
        step () {
            if(this.type === "float") return "any"
            if(this.type === "number") return "1"
            return false
        }
    },
    props: {
        saving: {
            type: Boolean,
            default: false
        }
    }
}
</script>
